import { BREAKPOINTS } from "../../constants/design";
export var defaultProps = {
  thresholdBreakpoint: BREAKPOINTS.md
};